<template>
  <div
    id="pinkfongproduct-card"
    class="card-body"
  >
    <v-btn
      v-if="item.orderCode"
      fab
      dark
      small
      color="rgb(90 90 90)"
      style="position: absolute; top:0px; left:0px; z-index:1;"
      @click="removeFromCart('pinkfongproducts', item)"
    >
      <span class="material-icons">
        delete_forever
      </span>
    </v-btn>
    <v-layout
      row
      wrap
      :class="{
        'box-paper-effect': cardLayout === 'card',
      }"
    >
      <v-flex
        v-bind="getLayout['outerLeftSide']"
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            v-bind="getLayout['innerHalfSide']"
            style="background-color: rgb(245 245 245); display:flex; justify-content: center; align-items:center;"
          >
            <!--섹터 1 : 이미지 칸-->
            <img
              class="card-img clickable"
              :src="img"
              style="display:block;"
              @click.stop="linkTo(getDetailUrl(item))"
              @load="setInfoDivOverflow()"
              ref="pfCardInfoTotal"
            >
          </v-flex>
          <v-flex
            v-if="!isRelatedCard"
            v-bind="getLayout['innerHalfSide']"
            :class="{
              'box-paper-effect': cardLayout !== 'card',
            }"
          >
            <v-layout col wrap>
              <!-- 제품 정보 영역-->
              <v-flex
                xs12
                class="card-info-data"
                :class="{
                  'one-col': cardLayout === 'oneCol',
                  'two-col': cardLayout === 'twoCol',
                  'card-col': cardLayout === 'card',
                  'over-flowed': isOverInfo,
                  'hidden': isOverInfo && !isOpenInfo,
                  'open': isOverInfo && isOpenInfo
                }"
                :style="{maxHeight: maxInfoHeight + 'px'}"
              >
                <div class="card-info-wrap" style="width: 100%; height:fit-content;" ref="pfCardInfoWrap">
                  <p
                    class="card-info-title clickable"
                    :class="{
                      'one-col': cardLayout === 'oneCol',
                      'two-col': cardLayout === 'twoCol',
                      'card-col': cardLayout === 'card',
                    }"
                    @click.stop="linkTo(getDetailUrl(item))"
                  >
                    {{ item.name }}
                  </p>
                  <p
                    v-if="item.orderCode && item.option.length > 0"
                    class="card-info-subtitle"
                    :class="{
                      'one-col': cardLayout === 'oneCol',
                      'two-col': cardLayout === 'twoCol',
                      'card-col': cardLayout === 'card',
                    }"
                    style="font-size:16px; margin:0px;"
                  >
                    {{ $t('newLP.options') }} : <b>{{ getOptionByCode(item.orderCode)["name"] }}</b>
                  </p>
                  <p
                    class="card-info-subtitle"
                    :class="{
                      'one-col': cardLayout === 'oneCol',
                      'two-col': cardLayout === 'twoCol',
                      'card-col': cardLayout === 'card',
                    }"
                    style="font-size:16px; padding-bottom:5px;"
                  >
                    <span v-if="isKorean()">
                      <span>{{ $t('newLP.price') + ": " }}</span><b>{{ item.price? parsePrice(item.price) : " - " }}</b><br/>
                    </span>
                    <span>{{ $t('newCartPage.MOQ') }}: {{ item.MOQ || 1 }}</span>
                  </p>
                  <p
                    class="card-info-content"
                    :class="{
                      'one-col': cardLayout === 'oneCol',
                      'two-col': cardLayout === 'twoCol',
                      'card-col': cardLayout === 'card',
                    }"
                  >
                    <span>
                      <a @click.stop="onClickLink({key:'category', id:item.category.id})">
                        {{ item.category.name }}
                      </a>
                      | {{ item.release }}
                    </span>
                  </p>
                  <p
                    class="card-info-content"
                    :class="{
                      'one-col': cardLayout === 'oneCol',
                      'two-col': cardLayout === 'twoCol',
                      'card-col': cardLayout === 'card',
                    }"
                  >
                    IP: {{ item.IP? item.IP.name : "" }}
                  </p>
                  <p
                    class="card-info-content"
                    :class="{
                      'one-col': cardLayout === 'oneCol',
                      'two-col': cardLayout === 'twoCol',
                      'card-col': cardLayout === 'card',
                    }"
                  >
                    {{ $t('newLP.sound') }}: {{ item.sound_language? item.sound_language.name : "없음" }}
                  </p>
                </div>
              </v-flex>
              <!-- 더보기 버튼 영역-->
              <v-flex
                v-if="isOverInfo"
                xs12
                class="show-more-wrap"
                style="padding-left:10px; padding-top:5px;"
              >
                <div
                  v-if="isOverInfo && !isOpenInfo"
                  class="card-info-show-more hover-pointer"
                  @click="isOpenInfo = !isOpenInfo"
                >
                  <v-icon style="font-size:20px; padding-bottom:1px; color: rgb(255 103 175);">keyboard_arrow_right</v-icon> {{ $t('newLP.more') }}
                </div>
                <div
                  v-else
                  class="card-info-show-more"
                />
                <div
                  v-if="isOverInfo && isOpenInfo"
                  class="card-info-show-more hover-pointer"
                  @click="isOpenInfo = !isOpenInfo"
                >
                  <v-icon style="font-size:20px; color: rgb(255 103 175);">keyboard_arrow_up</v-icon> {{ $t('newLP.closeMore') }}
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            v-else
            v-bind="getLayout['innerHalfSide']"
          >
            <p
              class="related-card-info-title"
            >
              {{ item.name }}
            </p>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        v-if="!isRelatedCard"
        v-bind="getLayout['outerRightSide']"
        style="display: flex; justify-content: center; align-items: center; position: relative;"
      >
        <v-layout
          v-if="!item.orderCode"
          class="list-btn-div"
          row
          wrap
          align-center
          justify-center
        >
          <v-flex
            v-if="item.option.length > 0"
            class="card-info-action"
            v-bind="getLayout['btnHalfSide']"
          >
            <multiselect
              v-model="selectedOption"
              track-by="code"
              label="name"
              :options="item.option"
              :searchable="false"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
              :placeholder="$t('newLP.selectOption')"
              style="width: 100%"
              @input="onSelectedOptionChanged('pinkfongproducts', item)"
            >
              <template
                slot="singleLabel"
                slot-scope="{ option }"
              >
                {{ option.name }}
              </template>
            </multiselect>
          </v-flex>
          <v-flex
            v-else
            class="card-info-action"
            v-bind="getLayout['btnHalfSide']"
          >
            <div
              class="fake-selector"
            />
          </v-flex>
          <v-flex
            class="card-info-action"
            v-bind="getLayout['btnHalfSide']"
          >
            <v-btn
              id="add-to-cart-btn"
              :style="{ backgroundColor: addToCartBtnColor }"
              @click="addToCart('pinkfongproducts', item)"
            >
              <div
                v-if="!isChecked"
                class="btn-text-field"
              >
                {{ $t('newLP.addCart') }}
              </div>
              <div
                v-if="isChecked"
                class="btn-text-field"
              >
                <div> {{ $t('newLP.alreadyAdded') }} </div>
                <i
                  class="icon material-icons"
                  style="padding-bottom: 8px; padding-left: 10px;"
                >
                  done
                </i>
              </div>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout
          v-else
          class="card-order-action-wrap"
          row
          wrap
          align-center
          justify-end
        >
          <v-flex
            class="card-order-action"
            v-bind="getLayout['btnHalfSide']"
          >
            <p class="card-order-action-title">
              {{ $t('newCartPage.quantity') }}
            </p>
            <v-text-field
              v-model.trim="item.orderQuantity"
              class="quantity-field"
              single-line
              :rules="[
                () => !!item.orderQuantity && isInt(item.orderQuantity)|| $t('newCartPage.quantityWarningField'),
                () => item.orderQuantity >= parseInt(item.MOQ) || $t('newCartPage.quantityWarningFieldMOQ')
              ]"
              required
            />
          </v-flex>
          <v-flex
            class="card-order-action"
            v-bind="getLayout['btnHalfSide']"
          >
            <p class="card-order-action-title">
              {{ $t('newCartPage.request') }}
            </p>
            <v-text-field
              v-model.trim="item.orderDescription"
              class="quantity-field"
              single-line
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Swal from 'sweetalert2'
import { bus } from '../../main'
const DEFAULT_ADD_TO_BTN_COLOR = 'rgb(255, 104, 175)'

export default {
  components: { Multiselect },
  // props: ['item', 'img', 'hash'],
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    img: {
      type: String,
      default: ''
    },
    hash: {
      type: String,
      default: ''
    },
    isRelatedCard: {
      type: Boolean,
      default: false
    },
    listLayout: {
      type: String,
      default: 'card'
    }
  },
  data () {
    return {
      selectedOption: null,
      isChecked: false,
      isOverInfo: false,
      isOpenInfo: false,
      cardLayout: 'card',
      maxInfoHeight: 0,
      addToCartBtnColor: DEFAULT_ADD_TO_BTN_COLOR,
      horizontalLayout: {
        outerLeftSide: {
          'xl8': true,
          'lg8': true,
          'md8': true,
          'sm12': true,
          'xs12': true
        },
        outerRightSide: {
          'xl4': true,
          'lg4': true,
          'md4': true,
          'sm12': true,
          'xs12': true
        },
        innerHalfSide: {
          'xl6': true,
          'lg6': true,
          'md6': true,
          'sm6': true,
          'xs12': true
        },
        bottomLeftSide: {
          'xl4': true,
          'lg4': true,
          'md4': true,
          'sm12': true,
          'xs12': true
        },
        bottomRightSide: {
          'xl8': true,
          'lg8': true,
          'md8': true,
          'sm12': true,
          'xs12': true
        },
        btnHalfSide: {
          'xl12': true,
          'lg12': true,
          'md12': true,
          'sm6': true,
          'xs12': true
        }
      },
      twoColLayout: {
        outerLeftSide: {
          'xl12': true,
          'lg12': true,
          'md12': true,
          'sm12': true,
          'xs12': true
        },
        outerRightSide: {
          'xl12': true,
          'lg12': true,
          'md12': true,
          'sm12': true,
          'xs12': true
        },
        innerHalfSide: {
          'xl6': true,
          'lg6': true,
          'md6': true,
          'sm12': true,
          'xs12': true
        },
        bottomLeftSide: {
          'xl12': true,
          'lg12': true,
          'md12': true,
          'sm12': true,
          'xs12': true
        },
        bottomRightSide: {
          'xl12': true,
          'lg12': true,
          'md12': true,
          'sm12': true,
          'xs12': true
        },
        btnHalfSide: {
          'xl6': true,
          'lg6': true,
          'md6': true,
          'sm12': true,
          'xs12': true
        }
      },
      verticalLayout: {
        outerLeftSide: {
          'xl12': true,
          'lg12': true,
          'md12': true,
          'sm12': true,
          'xs12': true
        },
        outerRightSide: {
          'xl12': true,
          'lg12': true,
          'md12': true,
          'sm12': true,
          'xs12': true
        },
        innerHalfSide: {
          'xl12': true,
          'lg12': true,
          'md12': true,
          'sm12': true,
          'xs12': true
        },
        bottomLeftSide: {
          'xl12': true,
          'lg12': true,
          'md12': true,
          'sm12': true,
          'xs12': true
        },
        bottomRightSide: {
          'xl12': true,
          'lg12': true,
          'md12': true,
          'sm12': true,
          'xs12': true
        },
        btnHalfSide: {
          'xl12': true,
          'lg12': true,
          'md12': true,
          'sm12': true,
          'xs12': true
        }
      }
    }
  },
  computed: {
    getLayout () {
      if (this.cardLayout === 'card') {
        return this.verticalLayout
      } else if (this.cardLayout === 'twoCol') {
        return this.twoColLayout
      } else {
        return this.horizontalLayout
      }
    }
  },
  watch: {
    '$store.getters.selected' () {
      this.updateChecked('pinkfongproducts', this.item)
    },
    'listLayout' () {
      this.setInfoDivOverflow()
    }
  },
  created () {
    window.addEventListener('resize', this.onResize)
  },
  destroyed () {
    this.$store.commit('listDeleted')
    window.removeEventListener('resize', this.onResize)
  },
  mounted () {
    this.updateChecked('pinkfongproducts', this.item)
    this.$nextTick(() => {
      this.setInfoDivOverflow()

      if (this.isOverFlag) {
        this.isOpenFlag = false
      }
      if (this.isOverInfo) {
        this.isOpenInfo = false
      }
    })
  },
  updated () {
    this.setInfoDivOverflow()
  },
  methods: {
    onResize () {
      this.setInfoDivOverflow()
    },
    setInfoDivOverflow () {
      switch (this.listLayout) {
        case 'oneCol':
          if (window.outerWidth < 600) {
            this.cardLayout = 'card'
          } else {
            this.cardLayout = 'oneCol'
          }
          break
        case 'twoCol':
          if (window.outerWidth < 1264) {
            this.cardLayout = 'card'
          } else {
            this.cardLayout = 'twoCol'
          }
          break
        case 'card':
          this.cardLayout = 'card'
          break
        default:
          this.cardLayout = 'card'
          break
      }

      if (this.cardLayout === 'oneCol') {
        this.isOverInfo = false
        return
      }

      if (!this.$refs.pfCardInfoTotal) return
      const parentHeight = this.$refs.pfCardInfoTotal.clientHeight
      let wrapMaxHeight = 0

      if (this.cardLayout === 'twoCol') {
        this.maxInfoHeight = parentHeight - 26
        wrapMaxHeight = parentHeight - 26
      }

      if (this.cardLayout === 'card') {
        this.maxInfoHeight = 151
        wrapMaxHeight = 151
      }

      if (this.$refs.pfCardInfoWrap === undefined) {
        this.isOverInfo = false
      }

      if (!this.$refs.pfCardInfoWrap) return

      if (this.$refs.pfCardInfoWrap.clientHeight > wrapMaxHeight) {
        this.isOverInfo = true
      } else {
        this.isOverInfo = false
      }
    },
    isInt (value) {
      const er = /^[0-9]+$/
      return er.test(value) && value > 0
    },
    getReleasedYearText (val) {
      const lang = this.$route.path.split('/')[1]
      if (lang === 'ko') {
        return val + '년 출시'
      } else {
        return 'Launched in ' + val
      }
    },
    getOptionByCode (code) {
      const index = this.item.option.findIndex(x => x.code === code)
      return this.item.option[index]
    },
    getDetailUrl (item) {
      let category = this.$route.params.category ? this.$route.params.category : 'all'
      return '/' + this.$language.locale + '/pinkfongproducts/' + category + '/' + item.code
    },
    linkTo (address) {
      this.$router.push(address)
    },
    getOrderCode (item) {
      const orderCode = item.option.length === 0 ? item.code : this.selectedOption.code
      return orderCode
    },
    updateChecked (product, item) {
      // 옵션 존재 상품인데 아직 미 선택 상태일 경우 false 리턴
      if (item.option.length > 0 && !this.selectedOption) {
        this.addToCartBtnColor = DEFAULT_ADD_TO_BTN_COLOR
        return false
      }

      const orderCode = this.getOrderCode(item)
      const isChecked = this.$store.getters.isCheckedItem(product, orderCode)
      if (isChecked) {
        this.addToCartBtnColor = 'rgb(255, 154, 201)'
        this.isChecked = true
      } else {
        this.addToCartBtnColor = DEFAULT_ADD_TO_BTN_COLOR
        this.isChecked = false
      }
    },
    onSelectedOptionChanged (product, item) {
      this.updateChecked(product, item)
    },
    addToCart (product, item) {
      if (item.option.length > 0 &&
          !this.selectedOption &&
          !this.isChecked) {
        Swal.fire({
          title: this.$t('newLP.noOptions'),
          icon: 'error'
        })
        return
      }
      const orderCode = this.getOrderCode(item)

      const payload = {
        ...item,
        orderCode,
        orderQuantity: item.MOQ || 1,
        orderDescription: '',
        product
      }

      this.$store.commit('toggleItem', payload)
      this.updateChecked(product, payload)
    },
    removeFromCart (product, item) {
      if (!this.item.orderCode) {
        return
      }
      const payload = {
        ...item,
        product
      }
      this.$store.commit('toggleItem', payload)
      this.updateChecked(product, payload)
    },
    onClickLink ({ key, id }) {
      const lang = this.$route.path.split('/')[1]
      const currCategory = this.$route.path.split('/')[3]

      this.$store.commit('setSingleFilter', { filter: key, id: id })
      if (currCategory === 'all') {
        bus.$emit('update-PF-filter')
      } else {
        this.$router.push({ path: `/${lang}/pinkfongproducts/all` })
      }
    },
    parsePrice (price) {
      if (price.value === 0) {
        return ' - '
      }
      return price.unit + price.value.toLocaleString()
    }
  }
}
</script>

<style>
  .card-body#pinkfongproduct-card {
    background-color: #ffffff;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  }

  .card-body#pinkfongproduct-card:hover {
    box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12)
  }

  .card-body#pinkfongproduct-card .card-img{
    width: 100%;
  }

  .card-body#pinkfongproduct-card .card-info-title{
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  .card-body#pinkfongproduct-card .card-info-title.one-col{
    font-size: 20px;
    font-weight: 600;
  }

  .card-body#pinkfongproduct-card .card-info-subtitle{
    font-size: 18px;
    margin-bottom: 0px;
  }

  .card-body#pinkfongproduct-card .card-info-subtitle.one-col{
    font-size: 18px;
    margin-bottom: 10px;
  }

  .card-body#pinkfongproduct-card .card-info-content{
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 0px;
  }

  .card-body#pinkfongproduct-card .card-info-content.one-col{
    font-size: 16px;
    margin-bottom: 5px;
  }

  .card-body#pinkfongproduct-card .card-btn-wrap{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
  }

  .card-body#pinkfongproduct-card .clickable{
    cursor: default;
  }
  .card-body#pinkfongproduct-card .clickable:hover{
    cursor: pointer;
  }
  .card-body#pinkfongproduct-card .card-info-country{
    font-size: 16px;
    padding: 10px;
  }
  .card-body#pinkfongproduct-card .card-info-country-tag{
    padding-left: 5px;
    padding-right: 5px;
    margin: 0px 5px 5px 0px;
    color: #fbffff;
    background-color: #828282;
    border-radius: 5px;
    font-weight: bold;
    width: fit-content !important;
  }

  .card-body#pinkfongproduct-card .text-field{
    padding: 10px;
    padding-bottom: 10px;
    width: 100%;
    height: 100%;
  }

  @media (min-width: 600px) {
    .card-body#pinkfongproduct-card .text-field{
      padding-left: 10px;
    }
  }

  @media (max-width: 959px) {
    .card-body#pinkfongproduct-card .card-info-action-wrap{
      padding-top: 10px;
    }
  }

  .card-body#pinkfongproduct-card .card-info-action{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
  }

  .card-body#pinkfongproduct-card .card-order-action{
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    padding: 10px;
  }

  .card-body#pinkfongproduct-card .card-order-action p.card-order-action-title{
    font-size: 16px;
    margin-bottom: 5px;
  }

  .card-body#pinkfongproduct-card .card-order-action p.card-order-action-content{
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 0px;
  }

  .card-body#pinkfongproduct-card #add-to-cart-btn{
    margin:0px;
    width: 100%;
    height: 40px;
    text-transform: inherit;
    background-color: #5a5a5a;
    color: white;
    font-weight: bold;
  }

  .card-body#pinkfongproduct-card #add-to-cart-btn .selected{
    margin:0px;
    width: 100%;
    height: 45px;
    text-transform: inherit;
    background-color: #5a5a5a;
    color: white;
    font-weight: bold;
  }

  .card-body#pinkfongproduct-card #add-to-cart-btn .btn-text-field{
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 1263px) {
    .card-body#pinkfongproduct-card .card-info-action{
      padding-bottom: 10px;
    }
  }

  /* vue-mulitiselect - 셀렉트 박스 LicenseProductCard 커스텀 */
  .card-body#pinkfongproduct-card .multiselect{
    width: 100%;
  }

  .card-body#pinkfongproduct-card button.swal2-styled.swal2-confirm{
    background-color: #5a5a5a;
    color: white;
    font-weight: bold;
    border-radius: 0px;
  }

  .card-body#pinkfongproduct-card .swal2-popup{
    border-radius: 0px;
  }

  .card-body#pinkfongproduct-card .card-order-action-wrap{
    height: 100%;
    background-color: rgb(245 245 245);
    padding-bottom: 10px;
  }

  .card-body#pinkfongproduct-card .card-order-action .v-input.v-text-field.v-text-field--single-line.theme--light {
    padding: 0px;
    margin: 0px;
  }

  .card-body#pinkfongproduct-card .card-order-action .v-input__control{
    height: 24px;
    position: relative;
  }

  .card-body#pinkfongproduct-card .card-order-action .v-input__slot input{
    padding: 0px;
  }

  .card-body#pinkfongproduct-card .card-order-action .v-text-field__details{
    padding: 0px;
    position: absolute;
    bottom: -17px;
  }

  .card-body#pinkfongproduct-card .related-card-info-title{
    padding: 10px;
    margin: 0px;
    font-size: 16px;
    font-weight: bold;
  }

  .card-body#pinkfongproduct-card .fake-selector{
    width: 100%;
    min-height: 40px;
    padding-top: 0px !important;
    padding-left: 8px !important;
    display: flex;
    align-items: center;
  }

  .card-body#pinkfongproduct-card .card-info-data{
    padding: 10px;
    padding-bottom: 0px;
  }
  .card-body#pinkfongproduct-card .card-info-data:not(.over-flowed){
    overflow: unset;
    max-height: unset !important;
    margin-bottom: 26px;
  }

  .card-body#pinkfongproduct-card .card-info-data:not(.over-flowed).one-col{
    margin-bottom: 0px;
  }

  .card-body#pinkfongproduct-card .card-info-data:not(.over-flowed).card-col{
    min-height: 151px;
  }

  .card-body#pinkfongproduct-card .card-info-data.over-flowed{
    overflow: hidden;
  }

  .card-body#pinkfongproduct-card .card-info-data.over-flowed.open{
    max-height: unset !important;
  }

  .card-body#pinkfongproduct-card .card-info-data.over-flowed.hidden{
    /* border-bottom: rgb(180, 180, 180) 1px dashed; */
  }

  .card-body#pinkfongproduct-card .show-more-wrap{
    min-height: 26px;
  }

  .card-body#pinkfongproduct-card .card-info-show-more{
    display:flex;
    align-items:center;
  }
</style>



// WEBPACK FOOTER //
// src/app/contents/PinkfongProductCard.vue